import React from "react";
import ContactForm from "./ContactForm";

function ContactFormModal() {
  return (
    <div className="modal fade" id="contact" role="dialog">
      <div
        className="modal-dialog modal-xl modal-dialog-centered"
        role="document"
      >
        <div className="modal-content prozo-modal-redesign">
          <div className="modal-body p-0">
            <button type="button" className="prozo-modal__close" data-dismiss="modal">
              <i className="mdi mdi-close" />
            </button>
            <div className="prozo-modal__grid">
              {/* Left branding panel */}
              <div className="prozo-modal__brand">
                <div className="prozo-modal__brand-content">
                  <img src="/media/Prozo-Logo.png" alt="Prozo" className="prozo-modal__logo" />
                  <h2 className="prozo-modal__tagline">
                    Quick Commerce First<br />
                    <span>Supply Chain Operating System</span>
                  </h2>
                  <p className="prozo-modal__subtitle">
                    for Omnichannel Brands Scaling Across India
                  </p>

                  <div className="prozo-modal__stats">
                    <div className="prozo-modal__stat">
                      <span className="prozo-modal__stat-num">50+</span>
                      <span className="prozo-modal__stat-label">Fulfilment Centres</span>
                    </div>
                    <div className="prozo-modal__stat">
                      <span className="prozo-modal__stat-num">3M+</span>
                      <span className="prozo-modal__stat-label">Sq. Ft.</span>
                    </div>
                    <div className="prozo-modal__stat">
                      <span className="prozo-modal__stat-num">120+</span>
                      <span className="prozo-modal__stat-label">Brands</span>
                    </div>
                  </div>

                  <div className="prozo-modal__capabilities">
                    <div className="prozo-modal__cap-item">
                      <i className="mdi mdi-warehouse" />
                      <span>Warehousing</span>
                    </div>
                    <div className="prozo-modal__cap-item">
                      <i className="mdi mdi-truck-fast" />
                      <span>Logistics</span>
                    </div>
                    <div className="prozo-modal__cap-item">
                      <i className="mdi mdi-monitor-dashboard" />
                      <span>Technology</span>
                    </div>
                    <div className="prozo-modal__cap-item">
                      <i className="mdi mdi-eye-outline" />
                      <span>Control Tower</span>
                    </div>
                  </div>
                </div>
              </div>

              {/* Right form panel */}
              <div className="prozo-modal__form">
                <div className="prozo-modal__form-inner">
                  <h3 className="prozo-modal__form-title">Say Hello</h3>
                  <p className="prozo-modal__form-desc">
                    Tell us what you're looking for and we'll get back within 24 hours.
                  </p>
                  <ContactForm hideHeading containerId="modal-form-container" />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default ContactFormModal;
